import moment from 'moment'

export const trimString = str => String(str).replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '')

const validator = {
  validateFormatEmail: {
    errorMessage: 'Endereço de e-mail inválido',
    isValid: input => validator.validateFormatEmail(input.value),
    isValueValid: value => (/^[-a-z0-9~!$%^&*_=+}{'?]+(\.[-a-z0-9~!$%^&*_=+}{'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i).test(value),
  },

  validateIn: {
    errorMessage: 'Opção inválida',
    isValid: (input, options) => validator.validateFormatEmail(input.value, options),
    isValueValid: (value, options) => options.map(String).indexOf(String(value)) >= 0,
  },

  validateRequired: {
    errorMessage: 'Preenchimento obrigatório',
    isValid: input => validator.validateRequired.isValueValid(input.value),
    isValueValid: value => value && trimString(value).length > 0,
  },

  validateDate: {
    errorMessage: 'Data inválida',
    isValid: (input, format = 'YYYY-MM-DD') => validator.validateDate.isValueValid(input.value, format),
    isValueValid: (value, format = 'YYYY-MM-DD') => value && trimString(value).length > 0 && moment(value, format).isValid(),
  },
}

export default validator



// WEBPACK FOOTER //
// ./src/helpers/validator.js